import { migrateFlowValueCollectorConfigs } from './migrateFlowValueCollectorConfigs';
window.__editorMigrations = {
    migrateFlowValueCollectorConfigs,
};
